import { useEffect, useState, type ReactNode } from "react";

import { useAuth } from "@/auth/AuthProvider";
import { isAdminAccount } from "@/auth/roles";
import { useSidebarCollapse } from "@/hooks/useSidebarCollapse";

import { Sidebar } from "./Sidebar";
import { TopBar } from "./TopBar";
import { ChevronLeftIcon } from "./NavIcons";

interface AppLayoutProps {
  children: ReactNode;
  pageContentClassName?: string;
}

export function AppLayout({ children, pageContentClassName }: AppLayoutProps) {
  const { user } = useAuth();
  const { collapsed, toggle: toggleCollapsed } = useSidebarCollapse();
  const [mobileOpen, setMobileOpen] = useState(false);
  const adminMode = isAdminAccount(user?.account_type);

  useEffect(() => {
    setMobileOpen(false);
  }, []);

  useEffect(() => {
    document.body.classList.toggle("admin-mode", adminMode);
    return () => {
      document.body.classList.remove("admin-mode");
    };
  }, [adminMode]);

  return (
    <>
      <button
        className="sidebar-toggle"
        onClick={() => setMobileOpen((v) => !v)}
        aria-label="Menu"
      >
        {"\u2630"}
      </button>

      <div className={`app-layout${collapsed ? " sidebar-collapsed" : ""}`}>
        <button
          className="sidebar-collapse-btn"
          onClick={toggleCollapsed}
          aria-label="Collapse sidebar"
        >
          <ChevronLeftIcon />
        </button>

        <Sidebar open={mobileOpen} onClose={() => setMobileOpen(false)} />

        <div className="main-content">
          {user && <TopBar />}
          <main
            className={`page-content${pageContentClassName ? " " + pageContentClassName : ""}`}
          >
            {children}
          </main>
        </div>
      </div>
    </>
  );
}
